import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShortTextIcon(props: IconProps) {
    return <Icon {...props} iconKey={"short_text"}/>
}
